import { render, staticRenderFns } from "./ObservacoesAgendamento.vue?vue&type=template&id=ec54273c&scoped=true&"
import script from "./ObservacoesAgendamento.vue?vue&type=script&lang=js&"
export * from "./ObservacoesAgendamento.vue?vue&type=script&lang=js&"
import style0 from "./ObservacoesAgendamento.vue?vue&type=style&index=0&id=ec54273c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec54273c",
  null
  
)

export default component.exports